/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

import { Confirm } from "src/refresh/service/constant";
import { Util } from "src/refresh/service/Util";
import { ItemList } from "../constant/item-list";
import { ApplicantVO, Cesp, PaymentVO, ProductRequestVO, RSF, ServiceRequest } from "../data/app-vo";
import { AboutChild, Contact, InputData, Name, OrderOfBC, ParentInfo, Subject } from "../data/input-data";
import { ApplicantCreator } from "./ApplicantCreator";
import { BirthCertificateRequestCreator } from "./BirthCertificateCreator";
import { SLBRequstCreator } from "./SLBRequestCreator";
var show = console.log.bind( console );

const ProductCode = {
      BR: 74,
      BCShort: 1,
      BCWithParent:89,
      BCLong:3,
      SIN:59,
      CCB:79,
      CESP:9999
}

export class InputDataToRSF {

       rsf:RSF = new RSF();
       serviceRequestList: ServiceRequest[];
       
       subject:Subject;
       data:InputData;

       sequence:number = 1;  // global.
       applicantCreator:ApplicantCreator;

       protected todayMMDD:string;

       constructor(private items:ItemList){}

       public create(theData:InputData) : RSF {
             
             this.applicantCreator = new ApplicantCreator();
             //--------------------------------------------------------
             this.rsf.status    = 1;     // RSF_STORED
             this.rsf.priority  = 2;     // RSF_PRIORITY_URGENT
             this.rsf.batchId   = this.getBatchId();
             this.rsf.contextRoot = 'IBR';
             //--------------------------------------------------------
             this.serviceRequestList = this.rsf.serviceRequests;
             this.subject = theData.subject;
             this.subject.total = 0;   
             
             this.subject.language = this.subject.language.substring(0,1).toUpperCase();            
            
             ///this.sortChildByBirthOrder();

             for ( let i = 0; i < this.subject.index; i++ ) {
                    this.data = this.subject.inputDataList[i];
                    this.dataProcess();
                    this.subject.total += this.data.orderOfBC.total;
                    this.eachChild(i);
             }

             if ( this.subject.total > 0 )
                  this.rsf.payment = this.createPayment();               

             return this.rsf;
       }

       /**
       private sortChildByBirthOrder() {
             
               this.subject.inputDataList.sort( (a,b) => {
                       return Number(a.aboutChild.birthOrder) - Number(b.aboutChild.birthOrder);
               });
       }
        */

       private getBatchId():number {
               let  today = Util.getToday();     // ex)20200220 without "-"
               this.todayMMDD = today.substring(4);
               return Number(today)*10;
       }

       private dataProcess() {

               let isSurrogacy = this.data.eligibility.isBornThroughSurrogacy == Confirm.YES;

               for ( let i = 0; i < this.data.eligibility.listedParentCount; i++  ) {
                     let parent = this.data.parents[i];

                     if ( Util.isEmpty(parent.lastNameAtBirth) ) parent.lastNameAtBirth = parent.name.getSingleOrLast();

                     if ( isSurrogacy ) {
                           parent.pregnancyDuration = null;
                           parent.howManyLiveborn  = 0;
                           parent.howManyStillborn = 0;
                     }
               }

               if ( isSurrogacy ) { 
                     this.data.contact.isParentSameAddr = '';
                     this.data.motherContact = null;
               }
       }
       
       private eachChild(index:number) {

               this.birthRegistration(index); 

               if ( this.data.orderOfBC.total > 0 ||
                    this.data.CCB.chk_consent == true ||
                    this.data.SIN.chk_read == true )  {

                        this.birthCertificate();  
               }
       }

       //===================================================================================================
       private birthRegistration(index:number) {

               let serviceRequest:ServiceRequest  = this.createServiceRequest(134);
                   serviceRequest.applicant = this.applicantCreator.create(this.subject.language,true,this.data);  // isBR=true

               //---- Birth Register -----
               serviceRequest.slbRequest = new SLBRequstCreator(this.items,this.data,this.todayMMDD).create();
               let birthOrder:number = Number(this.data.aboutChild.birthOrder);
               serviceRequest.slbRequest.birthSequence = birthOrder;  
               serviceRequest.slbRequest.childrenLiveborn += birthOrder;
               serviceRequest.slbRequest.childrenBorn =  serviceRequest.slbRequest.childrenLiveborn
                                                       + serviceRequest.slbRequest.childrenStillborn;

               if ( this.data.CESP.chk_consent == true )
               {
                    serviceRequest.cesp = this.createCesp();
                    serviceRequest.cesp.seqNumber = serviceRequest.serviceRequestSeq;
               }
               
               //---- product List -----
               this.BRProductListProcess(serviceRequest.productRequests);
       }

       //==============================================================================
       private createServiceRequest(serviceType:number) {

               let serviceRequest:ServiceRequest  = new ServiceRequest();

               serviceRequest.serviceType = serviceType;
               serviceRequest.subjectName = this.getSubjectName();
               serviceRequest.status =  2;   // default is 2
               serviceRequest.source = 'I';  
               serviceRequest.serviceLanguage   = this.subject.language;
               serviceRequest.serviceRequestSeq = this.sequence++;

               serviceRequest.eventDate = this.data.aboutChild.birthDay;

               this.serviceRequestList.push(serviceRequest);

               return serviceRequest;
       }


       //===================================================================================================
       private birthCertificate() {

               let serviceRequest:ServiceRequest  = this.createServiceRequest(0);
                   serviceRequest.applicant = this.applicantCreator.create(this.subject.language,false,this.data);

               //----- BirthCertificateRequest --- 
               serviceRequest.birthCertificateReq = new BirthCertificateRequestCreator(this.items,this.data,this.todayMMDD).create();

               //---- product List -----
               this.BCProductListProcess(serviceRequest.productRequests);
       }

       //---------------------------------------------------------------------------------------------
       private getSubjectName():string {      // for ServiceRequest : no Middle Name : LastName, FirstName
            
               let name:Name = this.data.aboutChild.name;

               if ( name.chk_singleName == Confirm.YES  ) return name.single;

               let subjectName = name.last + ", " + name.first;   
               if ( Util.isEmpty(name.middle) == false ) subjectName += " " + name.middle;   // one space , no middle name

               //return subjectName.toUpperCase();
               return subjectName;
       }

       //===============================================================================================
       private BRProductListProcess(productRequests:ProductRequestVO[]) {
               productRequests.push(this.addProduct(ProductCode.BR,null));
       }

       //===============================================================================================
       private BCProductListProcess(productRequests:ProductRequestVO[]) {
               let order:OrderOfBC = this.data.orderOfBC;

               if ( order.hasBCWithParentInfo == Confirm.YES ) 
                    productRequests.push(this.addProduct(ProductCode.BCWithParent,order.amountForBCWithParent));
               
               if ( order.hasBirthCertificate == Confirm.YES ) 
                    productRequests.push(this.addProduct(ProductCode.BCShort,order.amountForBC));
               
               if ( order.hasCertifiedCopyOfBR == Confirm.YES ) 
                    productRequests.push(this.addProduct(ProductCode.BCLong,order.amountForCertifiedCopy));
               
               if ( this.data.CCB.chk_consent == true ) 
                    productRequests.push(this.addProduct(ProductCode.CCB,null));

               if ( this.data.SIN.chk_read == true ) 
                    productRequests.push(this.addProduct(ProductCode.SIN,null));
       }

       //-------------------------------------------------------------------------
       private addProduct(code:number,amount:number) {

               let productRequest:ProductRequestVO = new ProductRequestVO();
               productRequest.status = 1;
               productRequest.productCode   = code;
               productRequest.serviceLevel  = 2;
               productRequest.numberItems   = 1;
               productRequest.unpaidBalance = amount;

               return productRequest;
       }

       //==========================================================================
       private createPayment() : PaymentVO {
               let payment:PaymentVO = new PaymentVO();

               payment.amount = this.subject.total;
               payment.status = 5;     // NOT_COMPLETED
               ////payment.applicantName = this.getApplicantName();

               return payment;
       }

       //-----------------------------------------------------------------------------
       /**
       private getApplicantName() : string {
               
               let applicant:ApplicantVO = this.serviceRequestList[0].applicant;
             
               let applicantName:string  =  applicant.givenName;

               if ( applicantName.length > 0 ) applicantName += " ";
                    applicantName += applicant.surname;
               
               if ( applicantName.length > 80 ) applicantName = applicantName.substring(0,80);

               return applicantName;
       }
        */

       //===================================================================================================
       private createCesp() : Cesp {

               let cesp:Cesp  = new Cesp();
               let CESP  = this.data.CESP;

               cesp.phone1 = this.getPhone(CESP.firstArea ,CESP.firstNumber1 ,CESP.firstNumber2);
               cesp.phone2 = this.getPhone(CESP.secondArea,CESP.secondNumber1,CESP.secondNumber2);

               cesp.phone1Ext = CESP.firstExt; 
               cesp.phone2Ext = CESP.secondExt; 

               cesp.phone1TTY = CESP.firstTTY;
               cesp.phone2TTY = CESP.secondTTY;

               if ( CESP.contactMethod )
                    cesp.contactMethod = Number(CESP.contactMethod);
               else cesp.contactMethod = 0;   

               if ( CESP.contactLang )
                    cesp.contactLanguage = Number(CESP.contactLang);
               else cesp.contactLanguage = 0;   

               if ( CESP.contactTime )
                    cesp.contactTime = Number(CESP.contactTime);
               else cesp.contactTime = 0;   
               
               if ( cesp.contactMethod == 1 ) {
                    cesp.email = null;
                    if ( !cesp.phone1TTY ) cesp.phone1TTY = 0;
                    if ( !cesp.phone2TTY ) cesp.phone2TTY = 0;
               }
               else 
               if ( cesp.contactMethod == 2 ) {
                     cesp.email = CESP.contactEmail;
                     cesp.phone1 = null;
                     cesp.phone2 = null;
                     cesp.phone1Ext = null;
                     cesp.phone2Ext = null;
                     cesp.phone1TTY = 0;
                     cesp.phone2TTY = 0;
               }

               if ( CESP.promoter ) {
                    cesp.financialOrganization = Util.padZero(CESP.promoter,4);
               }
               
               let child:AboutChild = this.data.aboutChild;
               cesp.childGivenName   = child.name.first;
               cesp.childSurname     = child.name.last;
               cesp.childDateOfBirth = this.data.aboutChild.birthDay; 

               if ( child.name.chk_singleName == Confirm.YES ) {
                    cesp.childSurname  = child.name.single; 
                    cesp.childGivenName = '';
               }

               let parent:ParentInfo = this.data.parents[CESP.contactParent];

               if ( parent.name.chk_singleName == Confirm.YES ) {
                    cesp.parentSurname    = parent.name.single;
                    cesp.parentGivenName  = "";
               }
               else {
                    cesp.parentGivenName  = parent.name.first;
                    cesp.parentSurname    = parent.name.last;
               }

               cesp.parentPostalCode = CESP.postalCode;  
               cesp.parentCountry    = CESP.country;     
               cesp.emailForReceipt  = CESP.emailForReceipt;
               cesp.bundle  = this.getBundle();
               cesp.consent =  CESP.chk_consent?'Y' : 'N';

               ///console.log(cesp);

               return cesp;
       }

       //-------------------------------------------------------------------------------------------------
       private getPhone(area:string, numb1:string,numb2:string) : string  {
               let phone = "";
               if ( area )  phone += area;
               if ( numb1 ) phone += numb1;
               if ( numb2 ) phone += Util.padZero(numb2,4);
               return phone;
       }


       //-------------------------------------------------------------------------------------------------
       private getBundle() :string {

            let isBirthCertificateApp:boolean = this.data.orderOfBC.total > 0;
            let CCBApp:boolean    = this.data.CCB.chk_consent == true;
            let isSINApp:boolean  = this.data.SIN.chk_read == true;
            let isCESPApp:boolean = this.data.CESP.chk_consent = true;

                  if      ( isBirthCertificateApp &&  CCBApp &&  isSINApp &&  isCESPApp) return "A";
                  else if ( isBirthCertificateApp &&  CCBApp && !isSINApp &&  isCESPApp) return "B";
                  else if ( isBirthCertificateApp && !CCBApp && !isSINApp &&  isCESPApp) return "C";
                  else if (!isBirthCertificateApp &&  CCBApp && !isSINApp &&  isCESPApp) return "D";
                  else if (!isBirthCertificateApp && !CCBApp && !isSINApp &&  isCESPApp) return "E";
                  else if ( isBirthCertificateApp && !CCBApp &&  isSINApp &&  isCESPApp) return "F";
                  else if (!isBirthCertificateApp &&  CCBApp &&  isSINApp &&  isCESPApp) return "G";
                  else if (!isBirthCertificateApp && !CCBApp &&  isSINApp &&  isCESPApp) return "H";
                  else if ( isBirthCertificateApp &&  CCBApp &&  isSINApp && !isCESPApp) return "I";
                  else if ( isBirthCertificateApp &&  CCBApp && !isSINApp && !isCESPApp) return "J";
                  else if ( isBirthCertificateApp && !CCBApp && !isSINApp && !isCESPApp) return "K";
                  else if (!isBirthCertificateApp &&  CCBApp && !isSINApp && !isCESPApp) return "L";
                  else if ( isBirthCertificateApp && !CCBApp &&  isSINApp && !isCESPApp) return "N";
                  else if (!isBirthCertificateApp &&  CCBApp &&  isSINApp && !isCESPApp) return "O";
                  else if (!isBirthCertificateApp && !CCBApp &&  isSINApp && !isCESPApp) return "P";
                  else return "M";
       }
}
